import axiosService from './axios.service';
import ResponseService from './response.service';

const list = async (
  _perPage,
  _page,
  _searchData,
  _sortBy,
  user_id,
  investmentType,
  sortUsing,
  sortOrder,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'owned_assets/list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        searchData: _searchData,
        sortBy: _sortBy,
        user_id: user_id,
        investmentType: investmentType,
        sortUsing: sortUsing,
        sortOrder: sortOrder,
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const details = async (_projectId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'projects/' + _projectId,
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const OwnedAssetService = {
  list,
  details,
};

export default OwnedAssetService;
